<app-snack-bar></app-snack-bar>
<div class="delivery-subscription-wrapper" id="confirmation-freshPass">
  <div class="ds-freshPass mt40">
    <div class="container p0 clear-fix" aria-label="section">
      <div *ngIf="userSubscriptionDetails">
        <app-customer-details-header-v2 [displaySubTypeLink]="displaySubTypeLink"
          [userSubscriptionDetails]="userSubscriptionDetails">
        </app-customer-details-header-v2>
      </div>
      <app-confirmation-notifications [userSubscriptionDetails]="userSubscriptionDetails"
        [subscriptionStatus]="subscriptionStatus" [status]="status" [hasCoupons]="hasCoupons">
      </app-confirmation-notifications>
    </div>
    <div class="loading-div-tiny mask" id="fp-loading">
      <div class="loading-spinner">
        <div alt="Loading..." class="large progress">
          <div class="prog1">
            <div class="prog2"></div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="coupons?.length > 0 || displayCreditPreview">
      <app-freshpass-perks [coupons]="coupons" [currentEnvironment]="currentEnvironment"
        [displayCreditPreview]="displayCreditPreview" [userSubscriptionDetails]="userSubscriptionDetails">
      </app-freshpass-perks>
    </div>
    <div *ngIf="isLtoCouponDataLoaded">
      <app-freshpass-lto [currentEnvironment]="currentEnvironment" [authUserInfo]="authUserInfo"
        [carouselData]="carouselData" [logoProps]="logoProps" [configObj]="configObj">
      </app-freshpass-lto>
    </div>
  </div>
  <div *ngIf="showPartnersComponent" class="container p0 clear-fix mb66">
    <app-partnerscarousel [carouselData]="partnersData" [configObj]="partnersConfigObj" [userInfo]="authUserInfo">
    </app-partnerscarousel>
  </div>
  <div class="container p0 clear-fix mb24" role="region">
    <div *ngIf="freshpassBenefitsJSON">
      <app-freshpass-benefits [currentEnvironment]="currentEnvironment" [freshpassBenefitsJSON]="freshpassBenefitsJSON">
      </app-freshpass-benefits>
    </div>
    <app-terms [currentEnvironment]="currentEnvironment" [userInfo]="userInfo"
      [userSubscriptionDetails]="userSubscriptionDetails">
    </app-terms>
  </div>
  <div>
    <app-vip-help></app-vip-help>
  </div>
</div>